import { useRef, useMemo, useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import 'quill-paste-smart';
import "./CustomLink";
import EditorTemplateModal from "../modals/EditorTemplateModal";
import ExpandEditor from "./ExpandEditor";
const Editor = ({
  images,
  image,
  editorFocussed,
  setEditorFocussed,
  setImages
}) => {
  const quillRef = useRef(null);
  const toolbarId = useRef(`toolbar-${Math.random().toString(36).substr(2, 9)}`).current;
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [savedPosition, setSavedPosition] = useState(null)
  const [expandEditorModal, setExpandEditorModal] = useState(false)

  useEffect(() => {
    if (!quillRef.current) return;
    const quill = quillRef?.current?.getEditor();
    const tooltip = quill.theme.tooltip;
    const originalShow = tooltip.show;
    tooltip.show = function () {
      const range = quill.getSelection();
      if (!range) return;
      const format = quill.getFormat(range);
      if (format.customLink) {
        return;
      }

      originalShow.apply(this, arguments);
    };
  }, [quillRef])

  const handleCustomLink = () => {
    const quill = quillRef.current.getEditor();
    const range = quill.getSelection();
    if (!range) return;

    const tooltip = quill.theme.tooltip;
    tooltip.edit("");
    tooltip.textbox.value = "";
    const originalSave = tooltip.save;

    tooltip.save = function () {
      const value = tooltip.textbox.value;
      if (value) {
        quill.format("customLink", value);
      } else {
        quill.format("customLink", false);
      }
      tooltip.hide();
      tooltip.save = originalSave;
    };
  };

  const openTemplateModal = () => {
    const quill = quillRef.current.getEditor();
    const range = quill.getSelection();
    if (!range) return;
    const position = range ? range.index : quill.getLength();
    setShowTemplateModal(true);
    setSavedPosition(position)
  }

  const onInsertTemplate = (content) => {
    const quill = quillRef.current.getEditor();
    const quillContainer = quill.root
    quill.clipboard.dangerouslyPasteHTML(savedPosition, content);
    const tempDiv = document.createElement("div")
    tempDiv.innerHTML = content
    const insertedLength = tempDiv.innerText.length
    const bounds = quill.getBounds(savedPosition + insertedLength);
    quillContainer.scrollTop = (bounds.top - quillContainer.clientHeight / 2)
    setShowTemplateModal(false)
    setSavedPosition(null)
  }


  const modules = useMemo(() => ({
    toolbar: {
      container: `#${toolbarId}`,
      handlers: {
        // customLink: () => {
        //   handleCustomLink();
        // }
        template: () => {
          openTemplateModal();
        },
        fullscreen: () => setExpandEditorModal(true)
      },
      keyboard: {
        bindings: {
          handleEnter: {
            key: [13, 'meta+enter'],
            handler: function (range, context) {
              const [line, offset] = this.quill.getLine(range.index);
              const lineText = line.domNode.textContent.trim();
              if (lineText === '') return false;
              return true;
            },
          },
        },
      },
    }
  }), []);

  const removeEmptyParagraphs = (html) => {
  return html
    .replace(/^(<p><br><\/p>\s*)+/g, '')
    .replace(/(\s*<p><br><\/p>)+$/g, '');
};

  return (
    <>
    <div className={`quill editor ${editorFocussed.name === image && editorFocussed.status ? 'focus-quill' : ''}`}>
      <div id={toolbarId}>
        <button className="ql-bold" />
        <button className="ql-italic" />
        <button className="ql-underline" />
        <button className="ql-blockquote" />
        <button className="ql-link" />
        <button className="ql-list" value="bullet" />
        <button className="ql-script" value="sub" />
        <button className="ql-script" value="super" />
        <button className="ql-template"><i className="fas fa-list-alt"></i></button>
        <button className="ql-fullscreen"><i className="fas fa-expand-alt"></i></button>
        {/* <button className="ql-customLink"><i className="fas fa-anchor"></i></button> */}
      </div>
      <ReactQuill
        ref={quillRef}
        theme="snow"
        modules={modules}
        placeholder='Type Here...'
        preserveWhitespace
        onFocus={() => setEditorFocussed({ name: image, status: true })}
        
        onChange={(e) => {
          if (editorFocussed?.name === image) {
            const newImages = images.map((item) => {
              if (item?.name === image) {
                return {
                  ...item,
                  methods: removeEmptyParagraphs(e.replaceAll('&nbsp;', ' '))
                }
              } else {
                return item
              }
            })
            setImages(newImages)
          }
        }}
        value={images.find((item) => item?.name === image)?.methods}
      />
    </div>
    {showTemplateModal && <EditorTemplateModal setShowTemplateModal={setShowTemplateModal} setSavedPosition={setSavedPosition} savedPosition={savedPosition} onInsertTemplate={onInsertTemplate} /> }
    {expandEditorModal && <ExpandEditor images={images} setImages={setImages} image={image} setExpandEditorModal={setExpandEditorModal} removeEmptyParagraphs={removeEmptyParagraphs} />}
    </>
  );
};

export default Editor;
